'use strict';

var NewCalibrationAnalysisHeaderDirective = function NewCalibrationAnalysisHeaderDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/new-calibration-analysis-header.html'),
    requires: '^rmNewCalibrationAnalysis',
    scope: false
  };
};
module.exports = NewCalibrationAnalysisHeaderDirective;